module.exports = __webpack_public_path__ + "media/pages/indonesian-005a20aa.jpg";